import { healthColor, healthTextClass } from '@/lib/format';

interface HealthRingProps {
  score: number | null;
  size?: number;
  strokeWidth?: number;
  showLabel?: boolean;
  className?: string;
}

export function HealthRing({ score, size = 56, strokeWidth = 4, showLabel = true, className = '' }: HealthRingProps) {
  const radius = (size - strokeWidth * 2) / 2;
  const circumference = 2 * Math.PI * radius;
  const pct = score !== null && score > 0 ? score / 100 : 0;
  const offset = circumference * (1 - pct);
  const center = size / 2;
  const displayScore = score !== null ? score : '—';

  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.06)"
          strokeWidth={strokeWidth}
        />
        {pct > 0 && (
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={healthColor(score)}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            transform={`rotate(-90 ${center} ${center})`}
            className="transition-[stroke-dashoffset] duration-700 ease-out"
          />
        )}
      </svg>
      {showLabel && (
        <div className={`absolute inset-0 flex items-center justify-center font-display font-bold ${healthTextClass(score)}`}
          style={{ fontSize: size * 0.016 + 'rem' }}
        >
          {displayScore}
        </div>
      )}
    </div>
  );
}
